import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    selector: String
  }

  declare selectorValue: string

  async #extendToFullscreen(container: Element): Promise<void> {
    if (container.requestFullscreen) {
      await container.requestFullscreen()
      // @ts-expect-error webkitRequestFullscreen (for Safari) is not recognised by TS
    } else if (container.webkitRequestFullscreen) {
      // @ts-expect-error webkitRequestFullscreen (for Safari) is not recognised by TS
      container.webkitRequestFullscreen()
    }
  }

  click(): void {
    const container = document.querySelector(this.selectorValue)
    if (container !== null) {
      void this.#extendToFullscreen(container)
    }
  }
}
